<!--
This component generates the pass list group for the specified {{status}.
Receiver must pass an array to {passData} to let the component generate the proper ui.
-->
<template>
  <section class="invite-section">
    <div class="list-group-container">
      <div class="d-flex flex-row list-row-header">
        <div class="p-2 w-50 first-column">Name</div>
        <div class="p-2 w-20">Actions</div>
      </div>

      <!--Appears if there's no agreement-->
      <div class="d-flex flex-row list-row-empty" v-if="!hasAgreements">
        <div class="flex-fill">No agreements yet.</div>
      </div>
      <!--end no agreement-->

      <!-- appears if with agreement/s -->
      <div class="list-rows" v-else>
        <div v-for="(data, index) in agreementsData" :key="index" class="d-flex flex-row list-row">
          <!-- if have other agreement name -->
          <div class="p-2 w-50 list-column-item first-column"
            v-if="data.other_agreement_name !== 'none'">
            <a class="simple-link" @click="goToNewTab(data, $event)">
              {{ data.other_agreement_name }}
            </a>
          </div>
          <!-- else if no other agreement name -->
          <div class="p-2 w-50 list-column-item first-column" v-else>
            <a class="simple-link" @click="goToNewTab(data, $event)">
              {{ data.agreement_name }}
            </a>
          </div>
          <!-- end if else -->

          <div class="p-2 list-column-action">
            <a class="simple-link" @click="goToNewTab(data, $event)">
              <i class="fas fa-eye"></i>
            </a>
          </div>
          <div class="p-2 list-column-action">
            <button class="simple-link" @click="editAgreement(data, $event)">
              <i class="fas fa-edit"></i>
            </button>
          </div>
          <div class="p-2 list-column-action"
            v-if="data.agreement_name === 'Data Privacy Agreement' ||
            data.other_agreement_name === 'Data Privacy Agreement'">
          </div>
          <div class="p-2 list-column-action" v-else>
            <button class="simple-link" @click="deleteAgreement(data, $event)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- end with agreements -->
    </div>
    <!--end list group-->
  </section>
</template>

<script>
import '@/assets/styles/list-style.css'

export default {
  name: 'agreement-list-view',
  data() {
    return {
      isToDelete: this.accountType === 'business'
    }
  },
  props: {
    accountType: String,
    agreementsData: Array,
    hasAgreements: Boolean,
    editAgreement: Function,
    deleteAgreement: Function,
    goToNewTab: Function
  }
}
</script>

<style scoped>
.invite-section {
  margin-top: 48px;
  width: 95%;
}
.invite-status-header {
  display:flex;
  align-items: center;
}
.invite-status-title {
  font-family: "HKGrotesk-Bold", Helvetica, sans-serif;
  color: #00386A;
  font-size: 20px;
}
.invite-status-indicator {
  width: 12px;
  height: 12px;

  border-radius: 100%;
  margin-right: 12px;
}

/* Status indicator color styles */
.status-active {
  background-color: #42BB79;
}
.status-inactive {
  background-color: #547181;
}
.status-pending {
  background-color: #EDC834;
}

/* list row header */
.list-row-header .p-2, .list-column-item {
  margin: 0px;
}

/deep/.first-column {
  margin: 0px 16px !important;
}

/deep/.simple-link {
  padding: 0px !important;
}

/* Media Small Screen */

@media (max-width: 568px) {
  .invite-section {
    margin-top: 20px;
    width: 85%;
    margin-left: auto;
    margin-right: auto;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/listview/AgreementListView.vue